import { useMe } from "@/frontend/shared/lib/hooks/useMe";
import { useEffect } from "react";
import { identifyByEmailPostHog } from "../model/services/identifyPostHog";

export function useIdentifySessionByEmail() {
  const { data, isLoading, isError } = useMe();

  useEffect(() => {
    if (data && !isLoading && !isError) {
      identifyByEmailPostHog(data.email);
    }
  }, [data, isLoading, isError]);

  return { isLoading, isError };
}
